export default function PlayerVsCpuIcon() {
  return (
    <svg width='82px' height='46px' viewBox='0 0 82 46' version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <title>player-vs-cpu</title>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='player-vs-cpu'>
          <circle id='Oval-Copy-20' fill='#FFFFFF' cx='59' cy='23' r='23'></circle>
          <g transform='translate(39.000000, 3.000000)'>
            <circle fill='#FD6687' cx='20' cy='20' r='20'></circle>
            <g transform='translate(10.000000, 12.500000)' stroke='#FFFFFF' strokeWidth='3'>
              <g id='Group-10'>
                <line x1='12.0833333' y1='0.416666667' x2='17.0833333' y2='0.416666667'></line>
                <line x1='2.91666667' y1='0.416666667' x2='7.91666667' y2='0.416666667'></line>
                <line x1='0' y1='6.25' x2='20' y2='6.25'></line>
              </g>
            </g>
          </g>
          <circle id='Oval-Copy-19' fill='#FFFFFF' cx='23' cy='23' r='23'></circle>
          <g id='Group' transform='translate(3.000000, 3.000000)'>
            <circle fill='#FD6687' cx='20' cy='20' r='20'></circle>
            <g transform='translate(10.000000, 11.666667)' stroke='#FFFFFF' strokeWidth='3'>
              <path d='M5,22.2916667 C10.5228475,22.2916667 15,17.8145142 15,12.2916667 C15,6.76881917 10.5228475,2.29166667 5,2.29166667' transform='translate(10.000000, 12.291667) rotate(90.000000) translate(-10.000000, -12.291667) '></path>
              <g transform='translate(5.625000, 0.000000)'>
                <line x1='0.416666667' y1='0' x2='0.416666667' y2='4.98700291'></line>
                <line x1='8.75' y1='0' x2='8.75' y2='4.98700291'></line>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
